var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7071 13.5104C23.3466 13.8885 22.7794 13.9176 22.3871 13.5977L22.2929 13.5104L12 2.71541L1.70711 13.5104C1.34662 13.8885 0.779392 13.9176 0.387101 13.5977L0.292893 13.5104C-0.0675907 13.1323 -0.0953203 12.5374 0.209705 12.1259L0.292893 12.0271L11.2929 0.489605C11.6534 0.111506 12.2206 0.0824213 12.6129 0.40235L12.7071 0.489605L23.7071 12.0271C24.0976 12.4367 24.0976 13.1008 23.7071 13.5104Z",
    fill: "#506991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.33538a176f352dd4eb4e86e5cf186351.svg";
export { ForwardRef as ReactComponent };